import { Component, OnInit } from '@angular/core';
import { ChoiceProcessModalComponent } from '../choice-process-modal/choice-process-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PreSales1ModalComponent } from '../pre-sales1-modal/pre-sales1-modal.component';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { AfterSales2ModalComponent } from '../after-sales2-modal/after-sales2-modal.component';

@Component({
  selector: 'app-after-sales1-modal',
  templateUrl: './after-sales1-modal.component.html',
  styleUrls: ['./after-sales1-modal.component.scss'],
})
export class AfterSales1ModalComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<PreSales1ModalComponent>,
    private api: BusApiService
  ) {}

  ngOnInit(): void {
    this.findBusSeats();
  }

  gotoChoiceModal() {
    this.dialogRef.close();
    this.dialog.open(ChoiceProcessModalComponent, {
      width: '471px',
    });
  }

  loading = false;
  page = 0;
  pageSize = 10;
  hasMore = true;
  seats: any = [];

  async findBusSeats() {
    try {
      this.page += 1;
      this.loading = true;
      const r = await this.api.findBusSeats(
        'Active',
        '',
        '',
        this.page,
        this.pageSize
      );
      const data = r.data || [];
      if (data.length < this.pageSize) {
        this.hasMore = false;
      }
      this.seats = this.seats.concat(data);
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  findMore() {
    this.findBusSeats();
  }

  openPlatformModal(data: any) {
    this.dialogRef.close();
    this.dialog.open(AfterSales2ModalComponent, {
      width: '712px',
      data: data,
    });
  }
}
